<template>
	<div class="m-grid__item m-grid__item--fluid m-wrapper user-info">
		<div class="m-content">
			<div class="row">
				<div class="col-xl-12">
					<div class="m-portlet m-portlet--full-height ">
						<div class="m-portlet__head row">
							<div class="col-xl-8 col-lg-12 col-md-12">
								<div class="row">
									<div class="col-3 m--margin-top-15">
										<input v-model="code" type="text" class="form-control m-input" placeholder="Nhập code">
									</div>
									<div class="col-4">
										<date-range-picker 
									        pickerId="agent-report"
									        v-on:date-change="onDateRangeChange"
									    ></date-range-picker>
									</div>
									<div class="col-3 m--margin-top-15">
										<select class="form-control m-input m-input--square" v-model="type_selected">
											<option value="1">Trạng thái</option>
											<option value="2">Tín dụng</option>
											<option value="3">Mật khẩu</option>
											<option value="4">Gia hạn</option>
											<option value="5">Thông tin</option>
											<option value="6">Thông số</option>
											<option value="7">Đăng nhập</option>
											<option value="8">Tăng cò</option>
											<option value="9">Khóa số</option>
										</select>
									</div>
									<div class="col-2 m--margin-top-15">
										<button @click="getLogsOnClick" class="btn btn-primary">Xem</button>
									</div>
								</div>
							</div>
							<div class="col-xl-4 col-lg-12 col-md-12">
							</div>
						</div>
						<div class="m-portlet__body">
							<div class="table_container">
								<table class='table m-table m-table--head-no-border'>
									<thead>
										<tr><th class='leftAlign'>Hành động</th><th class='leftAlign'>Chi tiết</th><th class='leftAlign'>IP</th></tr>
									</thead>
									<tbody v-html="tbody"></tbody>
								</table>
							</div>
							<div class="table_paging">
								<ul class="pagination">
									<li :class="'prev page-item '+(paging.last_page==1?'disabled':'')"><a @click="onPrev" class="page-link" href="javascript:;"><i class="la la-angle-left"></i></a></li>
									<li :class="'page-item '+(paging.current_page==page?'active':'')" v-for="page in (paging.total)"><a @click="goToPage(page)" class="page-link" href="#">{{page}}</a></li>
									<li :class="'next page-item '+(paging.last_page==1?'disabled':'')"><a @click="onNext" class="page-link" href="javascript:;"><i class="la la-angle-right"></i></a></li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import DateRangePicker from '../components/DateRangePicker';
	import { Utilities } from "../utilities";

    export default {
		data() {
            return {
            	from: "",
            	to: "",
            	code: "",
            	type_selected: 1,
				logs: [],
				tbody: "<tr coldspan='3'><td>Chưa có dữ liệu</td></tr>",
				paging: {total:0, current_page:1,last_page:1}
            }
        },

        created: function(){
        	// this.getLogs();
        },

        computed: {
			...mapGetters({
				user: 'user',
		  		userBudget: 'userBudget',
		  		gameInfo: 'gameInfo'
			}),
		},
		components:{
	        'date-range-picker': DateRangePicker,
	    },

        methods: {
			onDateRangeChange: function(start, end){
	            this.from = start;
	            this.to = end;

	            // this.fetchData();
	        },
			getLogsOnClick: function() {
				this.getLogs(1);
			},
			goToPage: function(page) {
				this.getLogs(page);
			},
			getLogs: async function(page = 1){
				let vm = this;
				let code = this.code.toLowerCase();
				let logs = await window.axios.get("/admin-panel/logs/type-"+this.type_selected+"?from="+this.from+"&to="+this.to+"&code="+code+"&page="+page);
	            this.paging = logs.data.data;
	            this.generateLog(this.type_selected, logs.data.data.data);
	            delete(this.paging.data);
			},
			onPrev: function(){
				if(this.paging.last_page == 1) return;
				if(!this.paging.prev_page_url) return;

				this.getLogs(this.paging.current_page - 1);
			},
			onNext: function(){
				if(this.paging.last_page == 1) return;
				if(!this.paging.next_page_url) return;

				this.getLogs(this.paging.current_page + 1);
			},
			generateLog: function(type, data){
				type = parseInt(type);
				let body = "";

				if(data.length == 0){
					this.tbody = "<tr coldspan='3'><td>Chưa có dữ liệu</td></tr>";
					return;
				}

				switch(type){
					case 1:
						body = this.generateTrangThaiLog(data);
						break;
					case 2:
						body = this.generateTinDungLog(data);
						break;
					case 3:
						body = this.generateMatKhauLog(data);
						break;
					case 4:
						body = this.generateGiaHanLog(data);
						break;
					case 5:
						body = this.generateThongTinLog(data);
						break;
					case 6:
						body = this.generateThongSoLog(data);
						break;
					case 7:
						body = this.generateDangNhapLog(data);
						break;
					case 8:
						body = this.generateTangCoLog(data);
						break;
					case 9:
						body = this.generateKhoaSoLog(data);
						break;
				}

				this.tbody = body;
			},
			parseDetail:function(detail){
				let vm = this;
				let pattern = /{.*?}/g;
				let pt = detail.match(pattern).map(function (s) { return s.replace("{","").replace("}",""); });
				for(let i=0;i<pt.length;i++){
					let part = pt[i].split("_");

					switch(part[0]){
						case "game":
							var alias = this.gameInfo.games[part[1]];
							detail = detail.replace("{"+pt[i]+"}", alias);
							break;
						case "prop":
							var alias = this.gameInfo.props[part[1]].toLowerCase();
							detail = detail.replace("{"+pt[i]+"}", alias);
							break;
						case "channel":
							if(part[1].indexOf(".") >= 0){
								let chns = part[1].split(".").map((cns) => { return vm.gameInfo.channels[parseInt(cns)].alias; });
			        			detail = detail.replace("{"+pt[i]+"}", chns.join(", "));
								continue;
							}

							detail = detail.replace( "{"+pt[i]+"}", vm.gameInfo.channels[parseInt(part[1])].alias );
							break;
					}
				}

				detail = detail.split(" | ").join("<br/>");
				return detail;
			},
			generateTrangThaiLog: function(data){
				let body = "";

				for(let i=0;i<data.length;i++){
					body += "<tr>";
					body += 	"<td class='leftAlign'>";
					body += 		"<span class='actionTitle'>Chỉnh sửa trạng thái của tài khoản "+data[i].code.toUpperCase()+"</span>";
					body +=			"<span class='actionSubTitle'>bởi "+data[i].created_by.toUpperCase()+" lúc "+data[i].time+"</span>";
					body += 	"</td>";
					body += 	"<td class='leftAlign'>"+data[i].detail+"</td>";
					body += 	"<td class='leftAlign'>"+data[i].ip+"</td>";
					body += "</tr>";
				}

				return 	body;
			},
			generateDangNhapLog: function(data){
				let body = "";

				for(let i=0;i<data.length;i++){
					body += "<tr>";
					body += 	"<td class='leftAlign'>";
					body += 		"<span class='actionTitle'>Đăng nhập vào hệ thống</span>";
					body +=			"<span class='actionSubTitle'>bởi "+data[i].created_by.toUpperCase()+" lúc "+data[i].time+"</span>";
					body += 	"</td>";
					body += 	"<td class='leftAlign'>"+data[i].detail+"</td>";
					body += 	"<td class='leftAlign'>"+data[i].ip+"</td>";
					body += "</tr>";
				}

				return 	body
			},
			generateMatKhauLog: function(data){
				let body = "";

				for(let i=0;i<data.length;i++){
					body += "<tr>";
					body += 	"<td class='leftAlign'>";
					body += 		"<span class='actionTitle'>Tài khoản "+data[i].code.toUpperCase()+" đổi mật khẩu thành công</span>";
					body +=			"<span class='actionSubTitle'>bởi "+data[i].created_by.toUpperCase()+" lúc "+data[i].time+"</span>";
					body += 	"</td>";
					body += 	"<td class='leftAlign'>"+data[i].detail+"</td>";
					body += 	"<td class='leftAlign'>"+data[i].ip+"</td>";
					body += "</tr>";
				}

				return 	body;
			},
			generateThongSoLog: function(data){
				let body = "";

				for(let i=0;i<data.length;i++){
					let detail = this.parseDetail(data[i].detail);

					body += "<tr>";
					body += 	"<td class='leftAlign'>";
					body += 		"<span class='actionTitle'>Thay đổi thông số tài khoản "+data[i].code.toUpperCase()+"</span>";
					body +=			"<span class='actionSubTitle'>bởi "+data[i].created_by.toUpperCase()+" lúc "+data[i].time+"</span>";
					body += 	"</td>";
					body += 	"<td class='leftAlign'>"+detail+"</td>";
					body += 	"<td class='leftAlign'>"+data[i].ip+"</td>";
					body += "</tr>";
				}

				return  body;
			},
			generateTangCoLog: function(data){
				let body = "";

				for(let i=0;i<data.length;i++){
					let detail = this.parseDetail(data[i].detail);

					body += "<tr>";
					body += 	"<td class='leftAlign'>";
					body += 		"<span class='actionTitle'>Thay đổi thông tin cò (commission) cho tài khoản "+data[i].code.toUpperCase()+"</span>";
					body +=			"<span class='actionSubTitle'>bởi "+data[i].created_by.toUpperCase()+" lúc "+data[i].time+"</span>";
					body += 	"</td>";
					body += 	"<td class='leftAlign'>"+detail+"</td>";
					body += 	"<td class='leftAlign'>"+data[i].ip+"</td>";
					body += "</tr>";
				}

				return  body;
			},
			generateKhoaSoLog: function(data){
				let body = "";

				for(let i=0;i<data.length;i++){
					let detail = this.parseDetail(data[i].detail);

					body += "<tr>";
					body += 	"<td class='leftAlign'>";
					body += 		"<span class='actionTitle'>Thay đổi thông tin khóa số cho tài khoản "+data[i].code.toUpperCase()+"</span>";
					body +=			"<span class='actionSubTitle'>bởi "+data[i].created_by.toUpperCase()+" lúc "+data[i].time+"</span>";
					body += 	"</td>";
					body += 	"<td class='leftAlign'>"+detail+"</td>";
					body += 	"<td class='leftAlign'>"+data[i].ip+"</td>";
					body += "</tr>";
				}

				return  body;
			},
			generateTinDungLog: function(data){
				let body = "";

				for(let i=0;i<data.length;i++){
					let detail = data[i].detail;

					body += "<tr>";
					body += 	"<td class='leftAlign'>";
					body += 		"<span class='actionTitle'>Thay đổi thông tin tín dụng cho tài khoản "+data[i].code.toUpperCase()+"</span>";
					body +=			"<span class='actionSubTitle'>bởi "+data[i].created_by.toUpperCase()+" lúc "+data[i].time+"</span>";
					body += 	"</td>";
					body += 	"<td class='leftAlign'>"+detail+"</td>";
					body += 	"<td class='leftAlign'>"+data[i].ip+"</td>";
					body += "</tr>";
				}

				return  body;
			},
			generateThongTinLog: function(data){
				let body = "";

				for(let i=0;i<data.length;i++){
					let detail = data[i].detail;

					body += "<tr>";
					body += 	"<td class='leftAlign'>";
					body += 		"<span class='actionTitle'>Thay đổi thông tin cho tài khoản "+data[i].code.toUpperCase()+"</span>";
					body +=			"<span class='actionSubTitle'>bởi "+data[i].created_by.toUpperCase()+" lúc "+data[i].time+"</span>";
					body += 	"</td>";
					body += 	"<td class='leftAlign'>"+detail+"</td>";
					body += 	"<td class='leftAlign'>"+data[i].ip+"</td>";
					body += "</tr>";
				}

				return  body;
			},
			generateGiaHanLog: function(data){
				let body = "";

				for(let i=0;i<data.length;i++){
					let detail = data[i].detail;

					body += "<tr>";
					body += 	"<td class='leftAlign'>";
					if(data[i].type == 4){
						body += 		"<span class='actionTitle'>Gia hạn tài khoản "+data[i].code.toUpperCase()+"</span>";
					}else{
						body += 		"<span class='actionTitle'> Xóa gia hạn tài khoản "+data[i].code.toUpperCase()+"</span>";
					}
					
					body +=			"<span class='actionSubTitle'>bởi "+data[i].created_by.toUpperCase()+" lúc "+data[i].time+"</span>";
					body += 	"</td>";
					body += 	"<td class='leftAlign'>"+detail+"</td>";
					body += 	"<td class='leftAlign'>"+data[i].ip+"</td>";
					body += "</tr>";
				}

				return  body;
			}
		}
	}
</script>

<style>
    .leftAlign{
    	text-align: left;
    }
    .actionTitle{
    	display: block;
    }
    .actionSubTitle{
    	font-style: italic;
    	display: block;
    }
    .m-subheader__daterange-label{
    	padding-right: 5px;
    }
    .table_paging .page-link{
    	border-radius: 50% !important;
	    cursor: pointer;
	    display: inline-block;
	    display: -webkit-box;
	    display: -ms-flexbox;
	    display: flex;
	    -moz-justify-content: center;
	    -ms-justify-content: center;
	    -webkit-box-pack: center;
	    -ms-flex-pack: center;
	    justify-content: center;
	    -moz-align-items: center;
	    -ms-align-items: center;
	    -webkit-box-align: center;
	    -ms-flex-align: center;
	    align-items: center;
	    text-align: center;
	    vertical-align: middle;
	    height: 2.25rem;
	    min-width: 2.25rem;
	    vertical-align: middle;
	    padding: 0.5rem;
	    text-align: center;
	    position: relative;
	    font-size: 1rem;
	    line-height: 1rem;
	    font-weight: 400;
    }
    .table_paging .page_item{
    	margin-left: 0.4rem;
    }
    .table_paging .page_item.disabled > .page-link{
	    opacity: .6;
    }
    .table_paging .page_item.prev > .page-link{
	    background: #ebe9f2;
    }
    .table_paging .page_item.next > .page-link{
	    background: #ebe9f2;
    }
</style>